import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { SearchSamplingPoint } from "@/types";
import { AppError } from "@/types/app.type";
import { ElForm, ElInput } from "element-plus";
import { reactive, ref } from "vue";
import { Refresh } from "@element-plus/icons-vue";

// - refs

export default /*#__PURE__*/_defineComponent({
  props: {
    values: null
  },
  emits: ["search"],
  setup(__props: any, { expose, emit }: { emit: ({
  (e: "search", searh: SearchSamplingPoint): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  values: SearchSamplingPoint | undefined;
}

const form = ref<InstanceType<typeof ElForm> | null>(null);
// const fieldQuery = ref<InstanceType<typeof ElInput> | null>(null);
const fieldQuery = ref<string>("SAMPLINGPOINT_NAME");

// - properties


// - events


// - modelo formulario
const formModel = reactive<SearchSamplingPoint>(props.values || { queryField: "ALL", query: "" });

// - validadores formulario
const rules = {};

// - methods
/**
 * method - onsubmit
 */
const onSubmit = async () => {
  if (!form.value) {
    return;
  }

  // - validate
  const valid = await form.value.validate();

  if (!valid) {
    throw new Error(AppError.FORM_VALIDATION);
  }

  // - emit search event
  emit("search", formModel);
};
const focus = () => {
  if (!fieldQuery.value) {
    return;
  }
  fieldQuery.value.focus();
};

const onClear = () => {
  formModel.query = "";
  formModel.queryField = "ALL";
  emit("search", { ...formModel });
};

expose({
  focus,
});

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createBlock(_unref(ElForm), {
    model: _unref(formModel),
    rules: rules,
    ref_key: "form",
    ref: form,
    onSubmit: _withModifiers(onSubmit, ["prevent"])
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_row, { gutter: 4 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 14 }, {
            default: _withCtx(() => [
              _createVNode(_unref(ElInput), {
                modelValue: _unref(formModel).query,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(formModel).query) = $event)),
                placeholder: _ctx.$t('placeholder.search'),
                ref_key: "fieldQuery",
                ref: fieldQuery
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 5 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                class: "btn",
                type: "primary",
                "native-type": "submit",
                style: {"width":"100%"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("placeholder.search")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 5 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_tooltip, {
                class: "box-item",
                effect: "dark",
                content: _ctx.$t('tooltip.refresh'),
                placement: "bottom"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    class: "btn",
                    icon: _unref(Refresh),
                    style: {"width":"100%"},
                    onClick: onClear
                  }, null, 8, ["icon"])
                ]),
                _: 1
              }, 8, ["content"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model", "onSubmit"]))
}
}

})